import type { StoreActionApi } from 'react-sweet-state';
import { fireUIMErrorAnalytics } from '@atlassian/jira-ui-modifications-analytics';
import { getAnalytics } from '@atlassian/jira-ui-modifications-fields-configuration';
import type {
	IssueAdjustmentsState,
	StoreContainerProps,
	ChangeId,
	BufferForChangeId,
} from '../../../types';

import { setError } from '../../errors';
import { unregisterAllFieldsOfChangeId } from '../../register-fields';
import { clearBufferForChangeId } from '../clear-buffer';
import { resetBufferErrors } from '../errors';

/*
 * Shared logic to handle error which affects all apps, hence state should be cleaned up for all apps.
 */
export const handleBufferAllAppsError =
	({
		err,
		changeId,
		bufferForChangeId,
	}: {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		err: any;
		changeId: ChangeId;
		bufferForChangeId: BufferForChangeId;
	}) =>
	(
		{ getState, dispatch }: StoreActionApi<IssueAdjustmentsState>,
		{ viewType, createAnalyticsEvent }: StoreContainerProps,
	) => {
		const {
			analyticsData: { issueAdjustmentModulesCount, configuredAppsCount, adjustmentsAPILatency },
		} = getState();
		const appIds: string[] = Object.keys(bufferForChangeId);

		dispatch(setError({ errorCode: 'APPLY_BUFFER_CHANGES_ERROR' }));
		dispatch(unregisterAllFieldsOfChangeId(changeId));
		dispatch(clearBufferForChangeId({ changeId }));
		dispatch(resetBufferErrors());

		getAnalytics(viewType).stopTTI({
			issueAdjustmentModulesCount,
			adjustmentsAPILatency,
			configuredAppsCount,
			completionStatus: 'error',
			viewType,
			appIds: appIds.join(),
		});

		fireUIMErrorAnalytics({
			error: err,
			id: 'bufferChanges',
			viewType,
			attributes: {
				errorCause: err?.cause,
			},
			event: createAnalyticsEvent({}),
		});
	};
